import { render } from "./Demography.vue?vue&type=template&id=14152970"
import script from "./Demography.vue?vue&type=script&lang=js"
export * from "./Demography.vue?vue&type=script&lang=js"

import "./Demography.vue?vue&type=style&index=0&id=14152970&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Demography.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "14152970"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('14152970', __exports__)) {
    api.reload('14152970', __exports__)
  }
  
  module.hot.accept("./Demography.vue?vue&type=template&id=14152970", () => {
    api.rerender('14152970', render)
  })

}


export default __exports__